module.exports = __webpack_public_path__ + "static/media/Welcome_back.91d805f4.svg";